// Wait for DOM document to load

//var tastyTest = "TASTY!!!";
$(document).ready(function () {
    // On click event upon all anchors starting with "#", call function with e (the event of the click) as the parameter
    $('a[href^="#"]').on('click', function (e) {
        // Cancel default behaviour/ event of the click on the anchor
        e.preventDefault();

        // The "target" variable gets assigned anchors value
        var target = this.hash;


        if (target !== '') {
            // The "target" variable is initialized as a JQuery variable
            var $target = $(target);
            if ($target.length) {
                // Stop current animation on html & body if any, and start new animation
                $('html, body').stop().animate({
                    //Use the 'scrollTop' method to get the vertical position of the scroll bar
                    //Based on $target value (which points to our anchor), offset position relative to the top of root
                    'scrollTop': $target.offset().top
                    //Do this in 900ms, use the 'swing' animation type, run next function
                }, 900, 'swing', function () {
                    //Use the window.location property to return the location/ URL of our "target" and add "hash" symbol?
                    window.location.hash = target;
                });
            }
        }
    });
});